<script lang="jsx">
import BaseTable from './_base-table'
import BaseIcon from './_base-icon'
import isFieldRestricted from '@utils/is-field-restricted'
import { h, withDirectives, resolveDirective } from 'vue'

export default {
  props: {
    fields: {
      type: Array,
      required: true,
    },
    valueHeadings: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    wrapValue(h, field) {
      return (
        {
          address: h('address', {}, field.value),
          'broker notes': h('span', {
            innerHTML:
              typeof field.value === 'string'
                ? field.value.trim().replace(/^<p>(.+?)<\/p>$/, '$1')
                : '',
          }),
        }[field.title.toLowerCase()] || field.value
      )
    },
    getIconAttrs(field) {
      if (field.icon) {
        return {
          name: field.icon,
          style: {
            color: field.restricted && this.$style.colorWarning,
          },
        }
      }

      const valueAttrsMap = {
        yes: {
          name: 'check',
          style: {
            color: this.$style.colorSuccess,
          },
        },
        no: {
          name: 'times',
          style: {
            color: this.$style.colorDanger,
          },
        },
        unknown: {
          name: 'question',
          style: {
            color: this.$style.colorText,
          },
        },
        restricted: {
          name: 'phone',
          style: {
            color: this.$style.colorWarning,
          },
        },
      }

      return (
        valueAttrsMap[
          typeof field.value === 'string' && field.value.toLowerCase()
        ] ||
        (field.restricted && valueAttrsMap.restricted) ||
        valueAttrsMap.unknown
      )
    },
  },
  render() {
    const normalizeText = (text) => {
      return (
        text &&
        text
          .toString()
          .replace(/_/g, ' ')
          .replace(/\bundefined\b/g, '?')
      )
    }

    return (
      <BaseTable>
        <tbody>
          {this.fields
            .map((field) => {
              return {
                ...field,
                title: normalizeText(field.title),
                value:
                  typeof field.value === 'function'
                    ? field.value(
                        h,
                        (value, fieldName) =>
                          value ||
                          (fieldName
                            ? field.restricted
                              ? 'Ask CHN for ' + fieldName
                              : fieldName + ' unknown'
                            : field.restricted
                              ? 'Ask CHN'
                              : 'unknown')
                      )
                    : {
                        true: 'Yes',
                        false: 'No',
                      }[field.value] ||
                      normalizeText(field.value) ||
                      (field.restricted
                        ? this.valueHeadings
                          ? 'Ask CHN'
                          : ' Ask CHN for ' + field.title
                        : this.valueHeadings
                          ? 'unknown'
                          : field.title + ' unknown'),
              }
            })
            .sort((a, b) => {
              if (!this.valueHeadings) return 0

              function rankValue(value) {
                return (
                  (value &&
                    {
                      yes: -1,
                      unknown: 0,
                      no: 1,
                    }[value && value.toLowerCase()]) ||
                  0
                )
              }

              return rankValue(a.value) - rankValue(b.value)
            })
            .map(
              (field) =>
                !field.hide &&
                (field.value || this.valueHeadings) &&
                h(
                  'tr',
                  {
                    key: field.title,
                  },
                  [
                    withDirectives(
                      h(
                        this.valueHeadings ? 'td' : 'th',
                        {
                          class: [
                            this.$style[this.valueHeadings ? 'td' : 'th'],
                            this.$style.iconCell,
                          ],
                          'aria-label': this.valueHeadings
                            ? field.value
                            : field.title,
                        },
                        [h(BaseIcon, this.getIconAttrs(field))]
                      ),
                      [
                        [
                          resolveDirective('tooltip'),
                          this.valueHeadings ? field.value : field.title,
                          JSON.stringify(
                            this.valueHeadings ? field.value : field.title
                          ),
                          {
                            'top-start': true,
                          },
                        ],
                      ]
                    ),
                    h(
                      this.valueHeadings ? 'th' : 'td',
                      {
                        class: this.$style[this.valueHeadings ? 'th' : 'td'],
                      },
                      [
                        withDirectives(
                          h(
                            'span',
                            {},
                            this.valueHeadings
                              ? field.title
                              : this.wrapValue(h, field)
                          ),
                          [
                            [
                              resolveDirective('tooltip'),
                              {
                                content: this.valueHeadings
                                  ? field.value
                                  : field.title,
                                placement: 'top-start',
                                'arrow-padding': 8,
                              },
                            ],
                          ]
                        ),
                        (field.fields || []).some(
                          (fieldPath) =>
                            !field.restricted && isFieldRestricted(...fieldPath)
                        )
                          ? withDirectives(h('span', {}, ' *'), [
                              [
                                resolveDirective('tooltip'),
                                'This field is restricted for some users',
                                '"This field is restricted for some users"',
                                {
                                  bottom: true,
                                },
                              ],
                            ])
                          : '',
                      ]
                    ),
                  ]
                )
            )}
        </tbody>
      </BaseTable>
    )
  },
}
</script>

<style lang="scss" module>
@use '@design' as *;

.th,
.td {
  label {
    vertical-align: text-top;
  }
}

.th {
  font-weight: normal;
  text-align: left;
}

.iconCell {
  text-align: center;
}
</style>
